import angular from 'angular';
import monthSelectorComponent from './monthSelector.component';

let monthSelectorModule = angular.module('monthSelector', [])

  .component('monthSelector', monthSelectorComponent)

  .name;

export default monthSelectorModule;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/features/teamCalendarMobile/monthSelector/monthSelector.js